import { BooleanField, CreateButton, Datagrid, FunctionField, List, TextField, TopToolbar } from "react-admin";

type Promo = {
  id: string;
  code: string;
  markup_pct: number;
  min_rub: number;
  max_rub: number | null;
  payment_requisites: Record<string, string> | null;
  rate_source: string;
  kyc_mode: string;
  show_support: boolean;
  show_referrals: boolean;
  show_cards: boolean;
  active: boolean;
  note: string | null;
};

const SOURCE_LABEL: Record<string, string> = { profinance: "Profinance", rapira: "Rapira" };
const KYC_LABEL: Record<string, string> = { internal: "Наша", sumsub: "Sumsub" };

const buttonsLabel = (r: Promo) => {
  const on = [
    r.show_cards && "Карты",
    r.show_referrals && "Партнёрам",
    r.show_support && "Техподдержка",
  ].filter(Boolean);
  if (on.length === 3) return "Все";
  return on.length ? on.join(", ") : "—";
};

const Actions = () => (
  <TopToolbar>
    <CreateButton label="Добавить код" />
  </TopToolbar>
);

export function PromoList() {
  return (
    <List actions={<Actions />} perPage={50} sort={{ field: "created_at", order: "DESC" }} exporter={false}>
      <Datagrid rowClick="edit" bulkActionButtons={false}>
        <TextField source="code" label="Код" />
        <FunctionField label="Наценка" render={(r: Promo) => `${Number(r.markup_pct)}%`} />
        <FunctionField label="Мин. пополнение" render={(r: Promo) => `${Number(r.min_rub).toLocaleString("ru-RU")} ₽`} />
        <FunctionField label="Макс. пополнение" render={(r: Promo) => (r.max_rub != null ? `${Number(r.max_rub).toLocaleString("ru-RU")} ₽` : "глобальный")} />
        <FunctionField label="Реквизиты" render={(r: Promo) => (r.payment_requisites && Object.keys(r.payment_requisites).length ? "свои" : "глобальные")} />
        <FunctionField label="Источник курса" render={(r: Promo) => SOURCE_LABEL[r.rate_source] || r.rate_source || "Profinance"} />
        <FunctionField label="Проверка" render={(r: Promo) => KYC_LABEL[r.kyc_mode] || r.kyc_mode || "Наша"} />
        <FunctionField label="Кнопки" render={buttonsLabel} />
        <BooleanField source="active" label="Активен" />
        <FunctionField label="Заметка" render={(r: Promo) => r.note || "—"} />
      </Datagrid>
    </List>
  );
}
